class ThemeAdmin {
  constructor() {
    themeBase.onDOMContentLoadedTrigger(() => {
      this.checkPreviewBarHeight();
    });
  }

  setCssPreviewBarHeight(height) {
    document.documentElement.style.setProperty('--preview-bar-iframe-height', `${Math.floor(height) / 10}rem`);
  }

  updatePreviewBarHeight() {
    const previewBarIframe = document.getElementById('preview-bar-iframe');
    if (!previewBarIframe) return;
    const height = parseInt(previewBarIframe.style.height);
    this.setCssPreviewBarHeight(isNaN(height) ? 0 : height);
  }

  checkPreviewBarHeight() {
    if (!Shopify.PreviewBarInjector || this.observedPreviewBar) return;

    const that = this;
    this.updatePreviewBarHeight();

    Shopify.PreviewBarInjector.prototype.postMessageHandler = (function(originalHandler) {
      return function(event, height, url, origin) {
        originalHandler.apply(this, arguments);

        if (that.previewBarRemoved) return;
        if (event === this.POST_MESSAGE_EVENTS.SET_IFRAME_HEIGHT) {
          that.setCssPreviewBarHeight(height);
        } else if (event === this.POST_MESSAGE_EVENTS.HIDE_IFRAME) {
          that.setCssPreviewBarHeight(0);
          that.previewBarRemoved = true;
        }
      };
    })(Shopify.PreviewBarInjector.prototype.postMessageHandler);
    this.observedPreviewBar = true;
  }
}

const themeAdmin = new ThemeAdmin;

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

themeBase.onDOMContentLoadedTrigger(() => {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', 'false');

    if (summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();
}

try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => {
    if (video.muted) return;

    video.pause();

    const rVideo = video.closest('rvideo-component');

    if (rVideo) rVideo.classList.add('rvideo-component--paused');
  });
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}

if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

function onTransitionEnd(element, callback) {
  const {
    transitionDuration,
    transitionDelay
  } = getComputedStyle(element);
  const duration = (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * 1000;

  duration > 0 ? element.addEventListener('transitionend', () => callback(), {
    once: true
  }) : callback();
}

class PushMessages extends HTMLElement {
  constructor() {
    super();

    themeBase.onDOMContentLoadedTrigger(() => {
      this.content = this.querySelector('.push-messages__content');

      this.content.addEventListener('transitionend', () => {
        if (!this.classList.contains('push-messages--show')) {
          this.content.innerHTML = '';
        }
      });
    });
  }

  startHideTimeout(hideTimeout) {
    if (!this.classList.contains('push-messages--show')) {
      return;
    }

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.toggle();
    }, hideTimeout);
  }

  push(errors = [], hideTimeout = 2000, showWarningIcon = true) {
    this.content = this.querySelector('.push-messages__content');
    let stringHTML = '';

    errors.forEach(error => {
      stringHTML += `<span class="error-line"><span>${error}</span>${showWarningIcon ? window.cartStrings.errorIcon : ''}</span>`;
    });

    if (!errors.length) {
      this.startHideTimeout(0);
      return;
    }

    if (this.content.innerHTML !== stringHTML) {
      this.content.innerHTML = stringHTML;
      this.toggle(true);
      this.startHideTimeout(hideTimeout);
    }
  }

  toggle(visible) {
    this.classList.toggle('push-messages--show', visible);
  }
}

customElements.define('push-messages', PushMessages);

scriptController.scripts.push('global.js');

themeBase.onDOMContentLoadedTrigger(() => {
  scriptController.onStyleReady(() => {
    class ModalDialog extends HTMLElement {
      constructor() {
        super();
        this.freezeClasslist = ['modal-dialog-opened'];
        this.bodyClasslist = [];

        this.deferredMedia = this.querySelector('deferred-media');
        delegate(this, 'click', '[id^="ModalClose-"], .js-modal-dialog-close', this.hide.bind(this));
        if (this.classList.contains('media-modal')) {
          this.addEventListener('pointerup', (event) => {
            if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
          });
        } else {
          this.addEventListener('click', (event) => {
            if (event.target === this) this.hide();
          });
        }

        this.onEscapeHandler = ((event) => {
          if (event && event.code.toUpperCase() === 'ESCAPE') this.hide();
        }).bind(this);

      }

      show(opener) {
        window.ModalDialogOpened = {
          modal: this,
          opener
        };
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        this.classList.add('ready');

        requestAnimationFrame(() => {
          themeBase.freezeScroll({
            additionalClass: this.freezeClasslist
          });
          themeBase.toogleClasslist(document.body, this.bodyClasslist, 'add');


          if (this.deferredMedia) window.pauseAllMedia();
          if (popup) popup.loadContent();

          themeBase.requestIdleCallback(() => {
            setTimeout(() => {
              this.setAttribute('open', '');
              this.dispatchEvent(new CustomEvent('modalOpened'));
              window.dispatchEvent(new CustomEvent('modalOpened'));
              document.body.addEventListener('keyup', this.onEscapeHandler);
            }, 50);
          });
        });
      }

      hide(callback) {
        document.body.removeEventListener('keyup', this.onEscapeHandler);

        if (this.openedBy?.blur) this.openedBy.blur();
        if (this.deferredMedia) window.pauseAllMedia();

        onTransitionEnd(this, () => {
          this.dispatchEvent(new CustomEvent('modalClosed'));
          window.dispatchEvent(new CustomEvent('modalClosed'));
          themeBase.unfreezeScroll({
            additionalClass: this.freezeClasslist
          });
          themeBase.toogleClasslist(document.body, this.bodyClasslist, 'remove');
          setTimeout(() => window.ModalDialogOpened = null, 10);

          if (typeof callback === 'function') {
            callback();
          }
        });

        requestAnimationFrame(() => this.removeAttribute('open'));
      }
    }

    window.ModalDialog = ModalDialog;
    customElements.define('modal-dialog', ModalDialog);
    requestAnimationFrame(() => scriptController.scripts.push('modal-dialog.js'));

    class ModalOpener extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button, a');
        this.button?.addEventListener('click', (event) => this.open(event));
      }

      open(event) {
        const modal = document.querySelector(this.getAttribute('data-modal'));

        if (modal && modal.show) {
          event.preventDefault();
          modal.show(this.button);
        }
      }
    }

    customElements.define('modal-opener', ModalOpener);
    requestAnimationFrame(() => scriptController.scripts.push('modal-opener.js'));
  }, ['base-interactions']);
});


//custom codes ---------------------------------------------------------------------------------------->>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

function replaceSelectedOfferFieldsets() {
  document.querySelectorAll("fieldset.js.product-form__input.swatches--").forEach(function(fieldset) {
    const legend = fieldset.querySelector("legend");
    if (legend && legend.textContent.trim() === "Selected Offer" && !fieldset.dataset.replaced) {
      
      // Get product URL from parent <variant-radios>
      const variantRadios = fieldset.closest("variant-radios");
      const productUrl = variantRadios ? variantRadios.dataset.url : "#";

      // Create clickable message
      const link = document.createElement("a");
      link.textContent = "Free Add-on Offers Available";
      link.href = productUrl;
      link.style.display = "inline-block";
      link.style.fontWeight = "600";
      link.style.color = "#9BCE33";
      link.style.textDecoration = "none";
      link.style.cursor = "pointer";

      // Replace fieldset with link
      fieldset.replaceWith(link);
      fieldset.dataset.replaced = "true";
    }
  });
}

// Watch for new nodes being added
const observer = new MutationObserver(() => {
  replaceSelectedOfferFieldsets();
});
observer.observe(document.body, { childList: true, subtree: true });

// Run once immediately
replaceSelectedOfferFieldsets();
